import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class CharacterNormalizationService {
	readonly specialCharMap: { [key: string]: string } = {
		Ŧ: 'T',
		ŧ: 't',
		Æ: 'AE',
		À: 'A',
		à: 'a',
		æ: 'ae',
		Đ: 'D',
		đ: 'd',
		Ł: 'L',
		ł: 'l',
		Č: 'C',
		č: 'c',
		Ć: 'C',
		ć: 'c',
		Ž: 'Z',
		ž: 'z',
		Š: 'S',
		š: 's',
		Dž: 'Dz',
		dž: 'dz',
		Ř: 'R',
		ř: 'r',
		Ď: 'D',
		ď: 'd',
		Ť: 'T',
		ť: 't',
		Ň: 'N',
		ň: 'n',
		Ä: 'A',
		ä: 'a',
		Ö: 'O',
		ö: 'o',
		Å: 'A',
		å: 'a',
		Ə: 'E',
		ə: 'e',
		Ø: 'E',
		ø: 'e',
		Α: 'A',
		α: 'a',
		Β: 'V',
		β: 'v',
		Γ: 'G',
		γ: 'g',
		Δ: 'D',
		δ: 'd',
		Ε: 'E',
		ε: 'e',
		Ζ: 'Z',
		ζ: 'z',
		Η: 'I',
		η: 'i',
		Θ: 'Th',
		θ: 'th',
		Ι: 'I',
		ι: 'i',
		Κ: 'K',
		κ: 'k',
		Λ: 'L',
		λ: 'l',
		Μ: 'M',
		μ: 'm',
		Ν: 'N',
		ν: 'n',
		Ξ: 'X',
		ξ: 'x',
		Ο: 'O',
		ο: 'o',
		Π: 'P',
		π: 'p',
		Ρ: 'R',
		ρ: 'r',
		Σ: 'S',
		σ: 's',
		Τ: 'T',
		τ: 't',
		Ü: 'U',
		ü: 'u',
		Υ: 'Y',
		υ: 'y',
		Φ: 'F',
		φ: 'f',
		Χ: 'Ch',
		χ: 'ch',
		Ψ: 'Ps',
		ψ: 'ps',
		Ω: 'O',
		ω: 'o',
		Á: 'A',
		á: 'a',
		É: 'E',
		é: 'e',
		Í: 'I',
		í: 'i',
		Ó: 'O',
		ó: 'o',
		Ú: 'U',
		ú: 'u',
		Ů: 'U',
		ů: 'u',
		Ą: 'A',
		ą: 'a',
		Ę: 'E',
		ę: 'e',
		Ń: 'N',
		ń: 'n',
		Ś: 'S',
		ś: 's',
		Ź: 'Z',
		ź: 'z',
		Ż: 'Z',
		ż: 'z',
		Ç: 'C',
		ç: 'c',
		È: 'E',
		è: 'e',
		Î: 'I',
		î: 'i',
		Ô: 'O',
		ô: 'o',
		Ù: 'U',
		ù: 'u',
		Â: 'A',
		â: 'a',
		Ê: 'E',
		ê: 'e',
		Û: 'U',
		û: 'u',
		Œ: 'OE',
		œ: 'oe',
		Ő: 'O',
		ő: 'o',
		Ű: 'U',
		ű: 'u',
		ß: 'SS',
		Ñ: 'N',
		ñ: 'n',
		Ĺ: 'L',
		ĺ: 'l',
		Ľ: 'L',
		ľ: 'l',
		Ș: 'S',
		ș: 's',
		Ț: 'T',
		ț: 't',
		Ă: 'A',
		ă: 'a',
		Є: 'Ye',
		є: 'ye',
		Ї: 'Yi',
		ї: 'yi',
		Ґ: 'G',
		ґ: 'g',
		Щ: 'Shch',
		щ: 'shch',
		Ю: 'Yu',
		ю: 'yu',
		Я: 'Ya',
		я: 'ya',
		А: 'A',
		а: 'a',
		Б: 'B',
		б: 'b',
		В: 'V',
		в: 'v',
		Г: 'G',
		г: 'g',
		Д: 'D',
		д: 'd',
		Е: 'E',
		е: 'e',
		Ж: 'Zh',
		ж: 'zh',
		З: 'Z',
		з: 'z',
		И: 'I',
		и: 'i',
		Й: 'Y',
		й: 'y',
		К: 'K',
		к: 'k',
		Л: 'L',
		л: 'l',
		М: 'M',
		м: 'm',
		Н: 'N',
		н: 'n',
		О: 'O',
		о: 'o',
		П: 'P',
		п: 'p',
		Р: 'R',
		р: 'r',
		С: 'S',
		с: 's',
		Т: 'T',
		т: 't',
		У: 'U',
		у: 'u',
		Ф: 'F',
		ф: 'f',
		Х: 'Kh',
		х: 'kh',
		Ц: 'Ts',
		ц: 'ts',
		Ч: 'Ch',
		ч: 'ch',
	};

	normalizeString(str: string): string {
		const normalizedStr = str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
		return normalizedStr
			.split('')
			.map((char) => this.specialCharMap[char] || char)
			.join('');
	}
}
